import { hDeepCopy } from '@/utils/helpers';
import {
  FILL_DETAILS,
  FILL_STATUS_LIST,
  FILL_CURRENT_CALL_DETAILS,
  FILL_SURVEY_INPUTS_LIST,
  FILL_SURVEY_LIST,
  FILL_CURRENT_CALL_SURVEY,
  FILL_SURVEY_QUESTIONS,
  FILL_LIST,
  FILL_SURVEY_RESULTS_LIST,
  FILL_SURVEY_ANSWERS,
  CLEAR_SURVEY_ANSWERS
} from './mutations-types';

export default {
  [FILL_LIST](state, payload) {
    const _state = state;
    _state.list.records = payload.records;
    _state.list.total = payload.total;
  },
  [FILL_SURVEY_RESULTS_LIST](state, payload) {
    const _state = state;
    _state.surveyResultslist.records = payload;
    _state.surveyResultslist.total = payload.length;
  },
  [FILL_DETAILS](state, payload) {
    const _state = state;
    _state.list.records = hDeepCopy(payload);
    _state.list.total = payload.length;
  },
  [FILL_STATUS_LIST](state, payload) {
    const _state = state;
    _state.statusAndRecordDictionary = payload;
  },
  [FILL_CURRENT_CALL_DETAILS](state, payload) {
    const _state = state;
    _state.currentCallDetails = payload;
  },
  [FILL_SURVEY_INPUTS_LIST](state, payload) {
    const _state = state;
    _state.surveyInputTypesList = payload;
  },
  [FILL_SURVEY_LIST](state, payload) {
    const _state = state;
    _state.surveysList = payload;
  },
  [FILL_CURRENT_CALL_SURVEY](state, payload) {
    const _state = state;
    _state.currentCallSurvey = payload;
  },
  [FILL_SURVEY_QUESTIONS](state, payload) {
    const _state = state;
    _state.surveyQuestions = payload;
  },
  [FILL_SURVEY_ANSWERS](state, payload) {
    const _state = state;
    _state.surveyAnswers = payload;
  },
  [CLEAR_SURVEY_ANSWERS](state,payload) {
    const _state = state;
    _state.surveyAnswers = [];
  }
};
